// Fixed 2-day handling + 3–5-day transit, matching Shopify Manual delivery dates.
// Shopify uses a noon cutoff; the eligible processing date is the date anchor.
const holidayCache = new Map();
const dateKey = date => date.toISOString().slice(0, 10);
function usHolidays(year) {
  if (holidayCache.has(year)) return holidayCache.get(year);
  const holidays = new Set();
  const date = (y, month, day) => new Date(Date.UTC(y, month - 1, day, 12));
  const observed = value => {
    if (value.getUTCDay() === 6) value.setUTCDate(value.getUTCDate() - 1);
    else if (value.getUTCDay() === 0) value.setUTCDate(value.getUTCDate() + 1);
    holidays.add(dateKey(value));
  };
  const nthWeekday = (month, weekday, occurrence) => {
    const first = date(year, month, 1);
    first.setUTCDate(1 + (weekday - first.getUTCDay() + 7) % 7 + 7 * (occurrence - 1));
    holidays.add(dateKey(first));
  };
  // US federal observed holidays; include next New Year's observance in December.
  for (const y of [year, year + 1]) observed(date(y, 1, 1));
  for (const [month, day] of [[6, 19], [7, 4], [11, 11], [12, 25]]) observed(date(year, month, day));
  for (const [month, weekday, occurrence] of [[1, 1, 3], [2, 1, 3], [9, 1, 1], [10, 1, 2], [11, 4, 4]]) nthWeekday(month, weekday, occurrence);
  const memorial = date(year, 5, 31);
  memorial.setUTCDate(31 - (memorial.getUTCDay() + 6) % 7);
  holidays.add(dateKey(memorial));
  holidayCache.set(year, holidays);
  return holidays;
}

export function getDeliveryEstimate(now = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', year: 'numeric', month: '2-digit',
    day: '2-digit', hour: '2-digit', hourCycle: 'h23',
  }).formatToParts(now).map(({ type, value }) => [type, value]));
  const first = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
  const isWeekday = date => date.getUTCDay() !== 0 && date.getUTCDay() !== 6
    && !usHolidays(date.getUTCFullYear()).has(dateKey(date));
  const advance = date => date.setUTCDate(date.getUTCDate() + 1);
  if (isWeekday(first) && Number(parts.hour) >= 12) advance(first);
  while (!isWeekday(first)) advance(first);
  const businessDay = number => {
    const date = new Date(first);
    for (let count = 0; count < number;) {
      advance(date);
      if (isWeekday(date)) count++;
    }
    return date;
  };
  return { first, earliest: businessDay(5), latest: businessDay(7) };
}

if (globalThis.customElements && !customElements.get('darido-delivery-estimate')) {
  customElements.define('darido-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.updateEstimate();
      this.timer = setInterval(() => this.updateEstimate(), 60_000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    updateEstimate() {
      const range = this.querySelector('[data-delivery-range]');
      if (!range) return;
      try {
        const { earliest, latest } = getDeliveryEstimate();
        const format = new Intl.DateTimeFormat('en-US', {
          weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC',
          ...(earliest.getUTCFullYear() !== latest.getUTCFullYear() ? { year: 'numeric' } : {}),
        });
        const text = `${format.format(earliest)} – ${format.format(latest)}`;
        if (range.textContent !== text) range.textContent = text;
      } catch {
        // Keep the readable 5–7 business-day fallback if date formatting is unavailable.
      }
    }
  });
}
